module.exports = __webpack_public_path__ + "static/media/center_logo.e27fafad.png";